<template>
  <div>
    <v-list-item
      :color="!item.disabled ? 'primary' : ''"
      v-for="(item, i) in menuItems"
      :key="i"
      :to="item.link"
      link
    >
      <v-list-item-action>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>{{ $t(item.text) }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import UserTypes from "../auth/userTypes";
export default {
  data() {
    return {
      menuItems: [],
      wertheimAdministrator: [
        {
          icon: "mdi-clipboard-text-multiple-outline",
          text: "productConfigurationsLabel",
          link: "/dashboard/products",
        },
        {
          icon: "mdi-file-document-edit-outline",
          text: "ordersLabel",
          link: "/dashboard/orders",
        },
        // {
        //   icon: "mdi-account-circle-outline",
        //   text: "profileLabel",
        //   link: "/dashboard/profile",
        // },
        {
          icon: "mdi-chart-tree",
          text: "protocolLabel",
          link: "/dashboard/protocol",
        },
        // {
        //   icon: "mdi-shopping-outline",
        //   text: "wertheimSalesLabel",
        //   link: "/dashboard/wertheim-sales",
        // },
        // {
        //   icon: "mdi-handshake",
        //   text: "salesPartnershipsLabel",
        //   link: "/dashboard/sale-partnerships",
        // },
      ],
      wertheimSales: [
        {
          icon: "mdi-clipboard-text-multiple-outline",
          text: "productConfigurationsLabel",
          link: "/dashboard/products",
        },
        {
          icon: "mdi-file-document-edit-outline",
          text: "ordersLabel",
          link: "/dashboard/orders",
        },
        // {
        //   icon: "mdi-account-circle-outline",
        //   text: "profileLabel",
        //   link: "/dashboard/profile",
        // },
        {
          icon: "mdi-chart-tree",
          text: "protocolLabel",
          link: "/dashboard/protocol",
        },
        // {
        //   icon: "mdi-handshake",
        //   text: "salesPartnershipsLabel",
        //   link: "/dashboard/sale-partnerships",
        // },
      ],
      salesPartnershipAdmin: [
        {
          icon: "mdi-clipboard-text-multiple-outline",
          text: "productConfigurationsLabel",
          link: "/dashboard/products",
        },
        {
          icon: "mdi-file-document-edit-outline",
          text: "ordersLabel",
          link: "/dashboard/orders",
        },
        // {
        //   icon: "mdi-account-circle-outline",
        //   text: "profileLabel",
        //   link: "/dashboard/profile",
        // },
        {
          icon: "mdi-chart-tree",
          text: "protocolLabel",
          link: "/dashboard/protocol",
        },
        // {
        //     icon: "mdi-handshake",
        //     text: "Users",
        //     link: "/dashboard/users"
        // },
        // {
        //   icon: "mdi-domain",
        //   text: "affiliatePartnershipSalesLabel",
        //   link: "/dashboard/affiliate-partnership-sales",
        // },
        // {
        //   icon: "mdi-chart-bar",
        //   text: "statisticsLabel",
        //   link: "/dashboard/statistics",
        // },
      ],
      salesPartnershipSales: [
        {
          icon: "mdi-clipboard-text-multiple-outline",
          text: "productConfigurationsLabel",
          link: "/dashboard/products",
        },
        {
          icon: "mdi-file-document-edit-outline",
          text: "ordersLabel",
          link: "/dashboard/orders",
        },
        // {
        //   icon: "mdi-account-circle-outline",
        //   text: "profileLabel",
        //   link: "/dashboard/profile",
        // },
        {
          icon: "mdi-chart-tree",
          text: "protocolLabel",
          link: "/dashboard/protocol",
        },
        // {
        //   icon: "mdi-chart-bar",
        //   text: "statisticsLabel",
        //   link: "/dashboard/statistics",
        // },
      ],
      salesPartnershipProductConfigurator: [
        {
          icon: "mdi-clipboard-text-multiple-outline",
          text: "productConfigurationsLabel",
          link: "/dashboard/products",
        },
        // {
        //   icon: "mdi-account-circle-outline",
        //   text: "profileLabel",
        //   link: "/dashboard/profile",
        // },
        {
          icon: "mdi-chart-tree",
          text: "protocolLabel",
          link: "/dashboard/protocol",
        },
        // {
        //   icon: "mdi-chart-bar",
        //   text: "statisticsLabel",
        //   link: "/dashboard/statistics",
        // },
      ],
      affiliatePartnershipSales: [
        {
          icon: "mdi-clipboard-text-multiple-outline",
          text: "productConfigurationsLabel",
          link: "/dashboard/products",
        },
        // {
        //   icon: "mdi-account-circle-outline",
        //   text: "profileLabel",
        //   link: "/dashboard/profile",
        // },
        {
          icon: "mdi-chart-tree",
          text: "protocolLabel",
          link: "/dashboard/protocol",
        },
        // {
        //   icon: "mdi-chart-bar",
        //   text: "statisticsLabel",
        //   link: "/dashboard/statistics",
        // },
      ],
    };
  },
  methods: {
    getUserType() {
      if (this.$store.getters.getUserType == UserTypes.WertheimAdministrator) {
        this.menuItems = this.wertheimAdministrator;
      }
      if (this.$store.getters.getUserType == UserTypes.WertheimSales) {
        this.menuItems = this.wertheimSales;
      }
      if (this.$store.getters.getUserType == UserTypes.SalesPartnershipAdmin) {
        this.menuItems = this.salesPartnershipAdmin;
      }
      if (this.$store.getters.getUserType == UserTypes.SalesPartnershipSales) {
        this.menuItems = this.salesPartnershipSales;
      }
      if (
        this.$store.getters.getUserType ==
        UserTypes.SalesPartnershipProductConfigurator
      ) {
        this.menuItems = this.salesPartnershipProductConfigurator;
      }
      if (
        this.$store.getters.getUserType == UserTypes.AffiliatePartnershipSales
      ) {
        this.menuItems = this.affiliatePartnershipSales;
      }
    },
  },
  mounted() {
    this.getUserType();
  },
};
</script>